const SIGNUP_LINK_STORAGE_KEY = "signupLinkParams";

/** Query params captured from unique signup links, e.g. `/signup?ref=connor`. */
export const SIGNUP_LINK_PARAMS = ["ref", "via", "source"];

export function captureSignupQueryParams(search) {
  const params = new URLSearchParams(
    search ?? (typeof window !== "undefined" ? window.location.search : ""),
  );
  const captured = {};

  SIGNUP_LINK_PARAMS.forEach((key) => {
    const value = params.get(key)?.trim();
    if (value) captured[key] = value;
  });

  if (Object.keys(captured).length > 0) {
    sessionStorage.setItem(SIGNUP_LINK_STORAGE_KEY, JSON.stringify(captured));
    return captured;
  }

  return getSignupQueryParams();
}

export function getSignupQueryParams() {
  try {
    const raw = sessionStorage.getItem(SIGNUP_LINK_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch {
    return {};
  }
}

export function getSignupSubscribeFields() {
  const params = getSignupQueryParams();
  const fields = { ...params };

  if (!fields.ref && params.via) {
    fields.ref = params.via;
  }

  return fields;
}

export function clearSignupQueryParams() {
  sessionStorage.removeItem(SIGNUP_LINK_STORAGE_KEY);
}

export function signupSubscribePath() {
  const params = getSignupQueryParams();
  const query = new URLSearchParams(params).toString();
  return query ? `/signup/subscribe?${query}` : "/signup/subscribe";
}
